import { render, staticRenderFns } from "./DeclareDetail.vue?vue&type=template&id=51848ae7&"
import script from "./DeclareDetail.vue?vue&type=script&lang=js&"
export * from "./DeclareDetail.vue?vue&type=script&lang=js&"
import style0 from "./DeclareDetail.vue?vue&type=style&index=0&id=51848ae7&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports